import React from 'react';
import { useTranslation } from 'react-i18next';

import { useConfirmAlert } from '@/js/libs/ui';

type UseConfirmation = () => (title: string, message: string) => Promise<boolean>;

// Shows a dialog to user. Returns an async function, that resolves as true if user answered "Yes" and as false
// otherwise. Simply `const confirm = useConfirmation()` and then `if( await confirm("title", "message") ) { ... }`
// Only reason this is a hook is because it needs translation to show button labels.
//
// NOTE: This is intended to be used as confirmation action only. If something more complicated is needed - implement
// it using ConfirmAlert
/**
 * @deprecated Use useConfirmation instead
 */
export const useConfirmationLegacy: UseConfirmation = () => {
  const { t } = useTranslation(['backend', 'common']);
  const confirmAlert = useConfirmAlert();
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line no-restricted-syntax
  return React.useCallback(
    async (title, message) =>
      new Promise((resolve) => {
        confirmAlert({
          title,
          message,
          buttons: [
            {
              label: t('common:YES_LABEL'),
              onClick: async (close) => {
                resolve(true);
                close();
              },
            },
            {
              label: t('common:NO_LABEL'),
              onClick: async (close) => {
                close();
                resolve(false);
              },
            },
          ],
          willUnmount: () => resolve(false),
          withoutClose: true,
          closeText: t('common:NO_LABEL'),
        });
      }),
    [t, confirmAlert],
  );
};
